<div class="row py-2 px-2 thinking-row">
  <div class="col-auto">
    <span class="loading-icon loading-pulse">
      @if (this.message().substring(0, 1).toLowerCase() === 's') {
      <i
        class="ri-send-plane-fill text-muted"
        style="position: relative;top:-2px"
      ></i>
      }
    </span>
    <div class="col">
      <small class="message">{{this.message()}}</small><br>
      <span class="type-writer">{{this.typeWriter.currStr}}</span>
    </div>


  </div>